import { ClientGateway } from "@kex/api";

import type { GetRequisitesMessagesHandler, RequisitesMessage } from "./types";

import { requisitesMessages } from "./messages";

export const getRequisitesCaptionMessages: GetRequisitesMessagesHandler<
  ClientGateway.BankAccountDetailsKyrgyzstanModel
> = (clientType, details) => {
  const messages: RequisitesMessage[] = [];

  const isIndividual = clientType === "PERSONAL";
  const isCompany = clientType === "COMPANY";

  if (isIndividual && details.iban) {
    messages.push({
      descriptor: requisitesMessages.iban,
      values: { ibanNumber: details.iban },
    });
  }

  if (isCompany && details.accountNumber) {
    messages.push({
      descriptor: requisitesMessages.accountNumber,
      values: { accountNumber: details.accountNumber },
    });
  }

  if (details.bik) {
    messages.push({
      descriptor: requisitesMessages.bik,
      values: { bikNumber: details.bik },
    });
  }

  return messages;
};

export const getRequisitesDetailsMessages: GetRequisitesMessagesHandler<
  ClientGateway.BankAccountDetailsKyrgyzstanModel
> = (clientType, details, name) => {
  const messages: RequisitesMessage[] = [];

  const isIndividual = clientType === "PERSONAL";
  const isCompany = clientType === "COMPANY";

  if (name) {
    messages.push({
      descriptor: requisitesMessages.name,
      values: { name },
    });
  }

  if (isIndividual && details.fullName) {
    messages.push({
      descriptor: requisitesMessages.fullName,
      values: { fullName: details.fullName },
    });
  }

  if (isIndividual && details.iban) {
    messages.push({
      descriptor: requisitesMessages.iban,
      values: { ibanNumber: details.iban },
    });
  }

  if (details.bik) {
    messages.push({
      descriptor: requisitesMessages.bik,
      values: { bikNumber: details.bik },
    });
  }

  if (details.bankName) {
    messages.push({
      descriptor: requisitesMessages.bankName,
      values: { bankName: details.bankName },
    });
  }

  if (isIndividual && details.cardNumber) {
    messages.push({
      descriptor: requisitesMessages.cardNumber,
      values: { cardNumber: details.cardNumber },
    });
  }

  if (isCompany && details.companyName) {
    messages.push({
      descriptor: requisitesMessages.companyName,
      values: { companyName: details.companyName },
    });
  }

  if (isCompany && details.pin) {
    messages.push({
      descriptor: requisitesMessages.pin,
      values: { pinNumber: details.pin },
    });
  }

  if (isCompany && details.accountNumber) {
    messages.push({
      descriptor: requisitesMessages.accountNumber,
      values: { accountNumber: details.accountNumber },
    });
  }

  if (isCompany && details.swift) {
    messages.push({
      descriptor: requisitesMessages.swift,
      values: { swiftCode: details.swift },
    });
  }

  return messages;
};
